import firebase, { storageRef, firebaseLooper } from "./firebase";

class MessagesService {
    messagesRef = firebase.database().ref("messages");
    typingRef = firebase.database().ref("typing");

    async createMessage(data, storageDir = "chat/public") {
        await this.messagesRef.child(data.channel.id).push().set(data);

        return await this.messagesRef
            .child(data.channel.id)
            .limitToLast(1)
            .once("value")
            .then(async snap => {
                const [message] = firebaseLooper(snap.val());

                // if (message?.image) message.image = await getImageDownloadURL(storageDir, message.image);

                return message;
            });
    }

    async getCurrentChannelMessages(channelId, storageDir = "chat/public") {
        const currentChannelMessages = await this.messagesRef
            .child(channelId)
            .once("value")
            .then(snap => firebaseLooper(snap.toJSON()));

        return currentChannelMessages.map(message =>
            message?.image ? { ...message, image: message.image.split("...")[0] } : message,
        );

        /*if (!currentChannelMessages.some(({ image }) => image)) return currentChannelMessages;

        const images = currentChannelMessages.map(({ image }) => image).filter(Boolean);
        //->>: SIMILAR APPROACH TO THE ABOVE BUT INSTEAD OF GET IMAGE-PROP THEN FILTER THE ITEM THAT NOT HAVE IMAGE-PROP WE MAKE CONDITION WITH .reduce-METHOD IF IMAGE-PROP TRUE WE RETURN IT WITHIN ACC IF NOT WE JUST PASS TO THE NEXT ITERATION BY RETURNING THE ACC.
        // const images = currentChannelMessages.reduce((acc, { image }) => image ? [...acc, image] : acc, []);

        const promises = images.map(async image => await getImageDownloadURL(storageDir, image));

        const messagesImages = await Promise.all(promises);

        return currentChannelMessages.map(message => {
            if (message?.image) message.image = messagesImages.find(messageImage => messageImage?.includes(message.image));

            return message;
        });*/
    }

    async deleteChannelMessages(channelId, storageDir = "chat/public") {
        await this.messagesRef
            .child(channelId)
            .once("value")
            .then(snap => firebaseLooper(snap.toJSON()))
            .then(messages =>
                messages
                    .map(({ image }) => image?.split("...")[1])
                    .filter(Boolean)
                    .forEach(async image => await storageRef(storageDir).child(image).delete()),
            );

        await this.messagesRef.child(channelId).remove();
    }

    async updateTyping(typing, channelId, user) {
        typing
            ? await this.typingRef.child(channelId).child(user.id).set(user.name)
            : await this.typingRef.child(channelId).child(user.id).remove();
    }

    setOnUpdateTypingListener(channelId, eventType, callback) {
        if (!channelId) return;

        this.typingRef.child(channelId).on(eventType, callback);
    }

    setOnAddMessageListener(channelId, callback) {
        if (!channelId) return;

        this.messagesRef.child(channelId).on("child_added", callback);
    }

    async removeChannelTypingRef(channelId) {
        await this.typingRef.child(channelId).remove();
    }

    get getTimestamp() {
        return firebase.database.ServerValue.TIMESTAMP;
    }
}

const messagesService = new MessagesService();

export default messagesService;
